export default __webpack_public_path__ + "img/7c5635f08ba7c43d7ec092c771966c9c.svg";